import moment from 'moment';

/* Saves CSV text as `<YYYY-MM-DD>-<facility>-<name>.csv` via a temporary link. */
export default function downloadCsv (csv: string, facilityName: string, name: string) {
  const today = moment().format('YYYY-MM-DD');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8,' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${today}-${facilityName}-${name}.csv`);
  link.click();
  URL.revokeObjectURL(url);
}
